{
  "static-content-download-app": {
    "buttons": {},
    "text": {
      "title": "Tải ứng dụng Beauty Booking",
      "description": "Hãy tải App ngay hôm nay để trải nghiệm những tiện ích tuyệt vời và những ưu đãi không giới hạn!"
    }
  }
}
